import request from "./client";

export const getById = async ({ id }) => {
  const resp = await request.get(`/v1/customers/${id}`);
  return { data: resp.body };
};
export const getSome = async ({ q = "", limit = 10, offset = 0 }) => {
  const query = new URLSearchParams({
    limit,
    offset,
    ...(q && { q }),
  }).toString();
  try {
    const resp = await request.get(`/v1/customers?${query}`);
    const body = resp.body;
    return { total: body.meta.total, data: body.results, error: null };
  } catch (e) {
    if (!e.response) {
      return { total: 0, data: [], error: e };
    }
    return { total: 0, data: [], error: e.response.body };
  }
};

export const updateOne = async ({ id, name, address, contact }) => {
  try {
    const resp = await request.put(`/v1/customers/${id}`).send({
      name,
      address,
      contact,
    });
    const body = resp.body;
    return { data: body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};

export const assignCustomer = async ({ id, assigned_to_id }) => {
  try {
    const resp = await request.patch(`/v1/customers/${id}/assign`).send({
      assigned_to_id,
    });
    return { data: resp.body, error: null };
  } catch (e) {
    if (!e.response) {
      return { data: null, error: e };
    }
    return { data: null, error: e.response };
  }
};
